<template>
  <div>
    <div style=" font-size: 18px;margin-top: -27px;padding-bottom: 20px;    text-align: center;">选择商务人员</div>
    <a-tree
      :data="salesmanData"
      show-checkbox
      default-expand-all
      node-key="id"
      ref="tree"
      :default-checked-keys="treeData"
      @check-change="handleSelectionChange"
      :props="defaultProps">
    </a-tree>
    <div slot="footer" class="dialog-footer" style="text-align: center;">
      <a-button type="primary" @click="cancel"
                 class="project-dialog-button">取消
      </a-button>
      <a-button type="primary" @click="save"
                 class="project-dialog-button">保存
      </a-button>
    </div>
  </div>

</template>

<script>
import { getSalesmanList } from '../../../api/salesman';
import { findOrderSalesman, saveOrderSalesman } from '../../../api/order';

async function getOrderSalesman() {
  this.salesmanData = [];
  const result = await getSalesmanList("0","9999");

  if (result.code === 1200) {
    this.salesmanData = result.data.salesmen;
  }
  this.treeData = [];
  const tree = await findOrderSalesman(this.form.data.id);
  if (tree.code === 1200) {
    const res = tree.data.salesmanOrders;

    res.forEach((x) => {

      this.treeData.push(x.id);
    });

    this.$nextTick(() => {
      this.$refs.tree.setCheckedKeys(this.treeData);// 获取已经设置的资源后渲染
    });
  }
}

async function save() {
  const res = await saveOrderSalesman(this.form.data.id, this.orderSalesmanTels);
  if (res.code === 1200) {
    this.$message({
      message: '商务人员绑定成功',
      type: 'success',
    });
  } else {
    this.$message({
      message: '商务人员绑定失败',
      type: 'fail',
    });
  }
  this.form.data = {};
  if (this.onSaveHandler) {
    this.onSaveHandler();
  }
}

function cancel() {
  this.form.data = {};
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}
function handleSelectionChange() {
  const res = this.$refs.tree.getCheckedNodes();
  this.orderSalesmanTels = '';
  res.forEach((item) => {
    this.orderSalesmanTels = `${this.orderSalesmanTels + item.telephone},`;
  });
}
export default {
  name: 'OrderSalesman',
  props: {
    orderId: String,
    onSaveHandler: Function,
    onCancelHandler: Function,
  },
  data() {
    return {
      treeData: [],
      salesmanData: [],
      orderSalesmanTels: '',
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      form: {
        data: {
          id: '',
          name: '',
        },
      },
      formRules: {},
    };
  },
  watch: {
    orderId(val) {
      this.form.data.id = val;
      this.getOrderSalesman();
    },
  },
  created() {
    this.form.data.id = this.orderId;
    this.getOrderSalesman();
  },
  methods: {
    save,
    cancel,
    getOrderSalesman,
    handleSelectionChange,
  },
};
</script>

<style scoped>

</style>
